<template>
  <scroll-view>
    <template slot-scope="visibility">
      <div class="centrum">
        <MainHeader :tiles="false" :fixedMenu="true" :dark="true" @logoClick="logoClick">
          <svg>
            <use v-if="selectedTranslation === 'en'" xlink:href="#logoCentrumSvgEng"></use>
            <use v-else xlink:href="#logoCentrumSvg"></use>
          </svg>
        </MainHeader>
        <div class="sections">
          <section class="section-main">
            <HeroCentrum
              :content="centrumData.top.header"
              :quote="centrumData.top.quote"
              key="HeroCentrum"
              :visible="visibility.HeroCentrum || isMobile"/>
          </section>
          <OverflowImageSection
            :description="centrumData.intro.akademia"
            image="monalisa"
            :link="(centrumData.sections[1] ? { name: 'centrum-edukacji-page', params: { page: 1 }} : false)"
            layout="right"
            key="OverflowImageSectionMonalisa"
            :visible="visibility.OverflowImageSectionMonalisa" />
          <OverflowImageSection
            :description="centrumData.intro.laboratorium"
            image="leonardo"
            :link="(centrumData.sections[2] ? { name: 'centrum-edukacji-page', params: { page: 2 }} : false)"
            key="OverflowImageSectionLeonardo"
            :visible="visibility.OverflowImageSectionLeonardo || isMobile" />
          <TilesIconsSection
            class="section-main"
            :tiles="centrumData.steam"
            :icons="true"
            key="TilesIconsSection"/>
          <ReverseColumsWithAnimatedImage
            :content="centrumData.cele"
            image="telescope"
            key="ReverseColumsWithAnimatedImage"
            :visible="visibility.ReverseColumsWithAnimatedImage || isMobile" />
          <TwoColumnsSection
            :columns="centrumData.columns"
            :background="true"
            key="TwoColumnsSection"
            :visible="visibility.TwoColumnsSection || isMobile" />
          <section class="section-main section-animated-shape text-center">
            <img src="@/assets/images/cekt/infinity-loop.gif" alt="Infinity loop" class="section-animated-shape-gif" />
          </section>
          <OverflowBlockquoteSection
            class="section-main"
            :description="centrumData.footer.oferta"
            :quote="centrumData.footer.quote"
            :link="(centrumData.sections[3] ? { name: 'centrum-edukacji-page', params: { page: 3 }} : false)"
            :scrollTop="visibility.OverflowBlockquoteSection"
            key="OverflowBlockquoteSection"
            :visible="visibility.OverflowBlockquoteSection" />
          <MainFooter
            key="footer"
            :visible="visibility.footer"
            :content="footerData"/>
        </div>
      </div>
    </template>
  </scroll-view>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import MainHeader from '@/components/MainHeader.vue'
import MainFooter from '@/components/MainFooter.vue'
import HeroCentrum from '@/components/HeroCentrum.vue'
import ReverseColumsWithAnimatedImage from '@/components/ReverseColumsWithAnimatedImage.vue'
import TilesIconsSection from '@/components/TilesIconsSection.vue'
import OverflowImageSection from '@/components/OverflowImageSection.vue'
import OverflowBlockquoteSection from '@/components/OverflowBlockquoteSection.vue'
import TwoColumnsSection from '@/components/TwoColumnsSection.vue'

export default {
  name: 'CentrumEdukacji',
  components: {
    MainHeader,
    MainFooter,
    HeroCentrum,
    ReverseColumsWithAnimatedImage,
    TilesIconsSection,
    OverflowImageSection,
    OverflowBlockquoteSection,
    TwoColumnsSection
  },
  methods: {
    ...mapActions([
      'resetActiveFilters'
    ]),
    logoClick () {
      this.$router.push({ 'name': 'centrum-edukacji' })
    }
  },
  computed: {
    ...mapGetters([
      'centrumData',
      'footerData',
      'breakpoint',
      'selectedTranslation'
    ]),
    isMobile () {
      return this.breakpoint === 'mobile' || this.breakpoint === 'tablet'
    },
    isPhone () {
      return this.breakpoint === 'mobile'
    }
  },
  mounted () {
    this.resetActiveFilters()
  }
}
</script>

<style scoped lang="scss">
  .centrum {
    width: 100%;
    overflow: hidden;

    /deep/ {
      & .main-header:not(.is-fixed) {
        button {
          filter: drop-shadow( 1px 1px 1px rgba(0,0,0,0.4) );
        }
      }
      & .mobile-bottom-menu {
        background: linear-gradient(rgba($bg-dark, 0), rgba($bg-dark, 0.75));
      }
    }
  } // END .centrum;
  .page-container {
    z-index: 99;
  }
  .section-animated-shape {
    position: relative;

    // .animated-shape,
    &-gif {
      margin: 0 auto;
      width: 60%;
      max-width: 370px;
    }
  }
</style>
